module.exports = __webpack_public_path__ + "img/logo-sena.fa5cc69c.svg";